import React, { useEffect, useState } from "react";
import { REQUEST_TARGET_MODULES } from "../../../Library/APIsTarget";
import LoadingBtn from "../../Widgets/LoadingBtn";

export default function CourseDetail({ course_id }) {
  const [course, setCourse] = useState({
    loading: true,
    data: [],
    message: "",
  });
  const ReloadCourse = async () => {
    setCourse({ loading: true, data: [], message: "" });
    const param_post = {
      parameters: { courseid: course_id },
      target_data: "GET_COURSE",
    };

    const results = await REQUEST_TARGET_MODULES(param_post);
    if (results.data && Object.values(results.data).length > 0) {
      const courses = results.data[0];
      let category_coures = "Regular";
      if (course.data.is_thesis === true) {
        category_coures = "Thesis";
      } else if (
        course.data.is_internship === true &&
        courses.data.internship &&
        Object.keys(courses.data.internship).length > 0
      ) {
        category_coures = courses.internship?.name;
      }
      courses.course_category = category_coures;
      setCourse({ loading: false, data: courses, message: "" });
    } else {
      setCourse(results);
    }
  };
  useEffect(() => {
    ReloadCourse();
  }, [course_id]);

  return course.loading ? (
    <LoadingBtn />
  ) : course.message ? (
    course.message
  ) : Object.values(course.data).length > 0 ? (
    <div>
      <div className="course-detail">
        <div className="d-flex">
          <div className="form-group mr-5">
            <label className="text-muted font-weight-bold">Course Code</label>
            <div className="text-dark font-weight-bold">{course.data.code}</div>
          </div>
          <div className="form-group">
            <label className="text-muted font-weight-bold">Course Title</label>
            <div className="text-dark font-weight-bold">
              {course.data.coursetitle}
            </div>
          </div>
        </div>

        <div className="d-flex">
          <div className="form-group">
            <label className="text-muted font-weight-bold">Credit</label>
            <div className="text-dark font-weight-bold">
              {course.data.credit} SKS
            </div>
          </div>
          <div className="form-group mx-5">
            <label className="text-muted font-weight-bold">ECTS</label>
            <div className="text-dark font-weight-bold">{course.data.ects}</div>
          </div>
          <div className="form-group mx-5">
            <label className="text-muted font-weight-bold">Total Lesson</label>
            <div className="text-dark font-weight-bold">
              {course.data.course_lesson}
            </div>
          </div>
          <div className="form-group mx-5">
            <label className="text-muted font-weight-bold">Score Type</label>
            <div className="text-dark font-weight-bold">
              {course.data.score_type && course.data.score_type === 1
                ? "NUMERIC"
                : "LETTER"}
            </div>
          </div>
          <div className="form-group mx-5">
            <label className="text-muted font-weight-bold">
              Chargeable Course
            </label>
            <div className="text-dark font-weight-bold">
              {course.data.not_billed && course.data.not_billed === 1
                ? "YES"
                : "NO"}
            </div>
          </div>
        </div>

        <div className="d-flex">
          <div className="form-group">
            <label className="text-muted font-weight-bold">Program</label>
            <div className="text-dark font-weight-bold">
              {course.data?.program?.name}
            </div>
          </div>
          <div className="form-group mx-5">
            <label className="text-muted font-weight-bold">Course Owner</label>
            <div className="text-dark font-weight-bold">
              {course.data?.course_owner_obj?.name}
            </div>
          </div>
          <div className="form-group mx-5">
            <label className="text-muted font-weight-bold">
              Course Category
            </label>
            <div className="text-dark font-weight-bold">
              {course.data?.course_category}
            </div>
          </div>
        </div>
      </div>

      <div className="course-prereq">
        <div className="table-responsive">
          <table className="table table-head-custom table-head-bg table-borderless table-vertical-center">
            <thead>
              <tr>
                <th colSpan={4}>
                  Course Prerequisite (
                  {Object.values(course.data.course_req).length})
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>Course</th>
                <th>Department</th>
                <th>Taken</th>
                <th>Pass</th>
              </tr>
              {course.data.course_req &&
              Object.values(course.data.course_req).length > 0 ? (
                course.data.course_req.map((course, index) => (
                  <TableRowCourse
                    key={index}
                    course={course.var_course}
                    type={course.coursereq_type}
                    clu={course.clu}
                  />
                ))
              ) : (
                <tr>
                  <td colSpan={4}> - </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className="course-eq">
        <div className="table-responsive">
          <table className="table table-head-custom table-head-bg table-borderless table-vertical-center">
            <thead>
              <tr>
                <th>
                  Course Equivalency (
                  {Object.values(course.data.course_eq).length})
                </th>
              </tr>
            </thead>
            <tbody>
              {course.data.course_eq &&
              Object.values(course.data.course_eq).length > 0 ? (
                course.data.course_eq.map((course, index) => (
                  <tr key={index}>
                    <td>
                      {course.t_course.code}·{course.t_course.coursetitle}·
                      {course.t_course.credit} SKS
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td> - </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  ) : (
    "No record found"
  );
}

const TableRowCourse = ({ course, type, clu }) => {
  return (
    <tr>
      <td>
        {course.code}·{course.coursetitle}·{course.credit} SKS
      </td>
      <td>{clu?.name}</td>
      <td>
        <CheckRequred />
      </td>
      <td>{type === "asc.course.req.type.pre.case2" && <CheckRequred />}</td>
    </tr>
  );
};

const CheckRequred = () => {
  return <i className="la la-check-circle icon-2x text-success"></i>;
};
